import { AppDetailsState } from '~/slices/appDetails';

/**
 * Gets the referral content identifier from groups array
 * @param groups - Array of group identifiers from app details
 * @param excludedGroups - Array of group identifiers to exclude (defaults to ['staff', 'directSmallBusiness'])
 * @returns The first group identifier that's not in excludedGroups, or undefined if none found
 */
export const getReferralContent = (
  groups?: AppDetailsState['groups'],
  excludedGroups: string[] = ['staff', 'directSmallBusiness']
): string | undefined => {
  if (!Array.isArray(groups)) {
    return undefined;
  }

  return groups.find((group) => !excludedGroups.includes(group));
};
